// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".collapse-container[data-v-10c3976d] {\n  background: #FF7058;\n  padding: 3px;\n  border-radius: 0px 0px 5px 5px;\n  width: 40%;\n}\n.collapse-container em[data-v-10c3976d] {\n  font-size: 12px;\n}\n.collapse-container span[data-v-10c3976d] {\n  font-size: 11px;\n}\n@media only screen and (max-width: 768px) {\n.collapse-container[data-v-10c3976d] {\n    width: 100%;\n}\n}", ""]);
// Exports
module.exports = exports;
